import { lazy, Suspense } from 'react';
import { View, StyleSheet } from 'react-native';
import { theme } from '@/constants/theme';
import type { Message, Course } from '@/types/chat';

const ChatMessage = lazy(() =>
  import('./ChatMessage').then(mod => ({ default: mod.ChatMessage }))
);

interface Props {
  message: Message;
  onBookCall?: (course: Course) => void;
  onMentorClick?: (mentorName: string) => void;
  skipTyping?: boolean;
  displayedCourses?: Course[];
  recommendedCourse?: Course;
  onEmailSubmit?: (email: string) => Promise<void>;
}

export function LazyChatMessage(props: Props) {
  return (
    // ✅ FIX: fallback has a real height so FlatList doesn't collapse the
    // row to 0 while ChatMessage is loading, which caused scroll miscalculation
    // and made messages appear to "disappear" until a re-render happened.
    <Suspense fallback={<View style={styles.placeholder} />}>
      <ChatMessage {...props} />
    </Suspense>
  );
}

const styles = StyleSheet.create({
  placeholder: {
    // Matches the approximate height of a single-line chat bubble
    minHeight: 56,
    marginVertical: theme.spacing.sm,
    paddingHorizontal: theme.spacing.md,
  },
});